<template>
  <div class="schema-panel">
    <div class="schema-panel__property" v-if="!!selectedBooth">
      <app-property
        v-for="prop in currentProject.schemaBoothProperties"
        :key="`schema-property-${prop.id}`"
        :property="prop"
        :propertyData="propertyData(prop.id)"
        @change="onPropertyChange(prop.id, $event)"
      ></app-property>
    </div>
  </div>
</template>

<script>
import AppProperty from "@/components/Property";

export default {
  props: {
    currentProject: {
      type: null
    },
    schema: {
      type: Object
    }
  },
  methods: {
    onPropertyChange(id, value) {
      this.$emit("property-changed", {
        boothId: this.selectedBooth,
        propId: id,
        value: value
      });
    },
    propertyData(id) {
      return (
        this.schema.data[this.selectedBooth] &&
        this.schema.data[this.selectedBooth][id]
      );
    }
  },
  computed: {
    selectedBooth() {
      return this.$store.state.selectedBooth;
    }
    // currentProps() {
    //   return (
    //     this.$store.state.project.projects[this.projectId] &&
    //     this.$store.state.project.projects[this.projectId].schemaBoothProperties
    //   );
    // }
  },
  components: {
    AppProperty
  }
};
</script>

<style lang="scss" scoped>
.schema-panel {
  position: relative;
  padding: 20px;
  min-width: 300px;

  &__property {
  }
}
</style>
